export default __webpack_public_path__ + "static/behavioral-automation-saas-356d415088781c982804b5c2cfa8b9c0.png";